import React from 'react';
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import CardHeader from '@mui/material/CardHeader';
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

const AccountPasswordForm = () => {
    return (
        <Card>
            <CardHeader subheader="Create your new password" title="Change password"/>
            <Divider/>
            <CardContent>
                <Grid
                    container
                    spacing={3}
                >
                    <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <TextField
                            fullWidth
                            helperText="Your current password"
                            label="Current password"
                            name="currentPassword"
                            required
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <TextField
                            fullWidth
                            helperText="New password"
                            label="New password"
                            name="newPassword"
                            required
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <Divider/>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    p: 2
                }}
            >
                <Button
                    color="primary"
                    variant="contained"
                >
                    Save details
                </Button>
            </Box>
        </Card>
    );
};

export default AccountPasswordForm;